var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaste = function SvgPaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.612 0c-.92 0-1.62.764-1.62 1.646v.129h-.774c-.652 0-1.278.258-1.74.718a2.451 2.451 0 0 0-.723 1.737v11.315c0 .652.26 1.277.723 1.737.462.46 1.088.718 1.74.718h9.562c.652 0 1.278-.258 1.74-.718.462-.46.723-1.085.723-1.737V4.23c0-.652-.26-1.277-.723-1.737a2.466 2.466 0 0 0-1.74-.718h-.775v-.129C13.005.764 12.306 0 11.386 0H6.612Zm.027 3.457v-1.81h4.72v1.81h-4.72Zm6.366-.036v.036c0 .883-.699 1.647-1.619 1.647H6.612c-.92 0-1.62-.764-1.62-1.647v-.036h-.774a.82.82 0 0 0-.579.238.805.805 0 0 0-.238.571v11.315c0 .213.085.418.238.57a.82.82 0 0 0 .579.239h9.562a.82.82 0 0 0 .579-.239.805.805 0 0 0 .237-.57V4.23a.805.805 0 0 0-.237-.57.82.82 0 0 0-.579-.239h-.775Z",
    fill: "currentColor"
  })));
};
export default SvgPaste;